




import {Component, Prop, Vue} from 'vue-property-decorator';
import MoreComponent from './MoreComponent.vue';

@Component({
  components: {
    MoreComponent,
  },
})
export default class MoreTwo extends Vue {
  private moreData = {
    pic: {
      height: '5.7rem',
      src: require('@/assets/images/5-2.png'),
    },
    avatarData: {
      avatar: require('@/assets/images/avatar-2.png'),
      name: '文海hai',
      article: [
        '2天用了3次一键加电，感觉特别棒！提车第一天满电，第二天中午嘚瑟的没电了，中午果断叫了一键加电。预计40分钟到公司，做了' +
        '提前预约，到了公司，正好加电小哥到达，交车加电。下班开去杭州，用了75%左右，离到达目的地提前约了一键加电，到了以后10分钟，' +
        '加电小哥来了！交车加电。然后我就美美哒去看电影了，邪不压正看好，出来正好小哥回来送车。安心接车睡觉。',
        '第三天早上去了周五，单程160公里，开到后周庄有快充。玩好回来满电就一路来回杭州。因为路途电够，就各种测试车性能！感觉只能说太' +
        '爽了。只能体会不能言传。中途服务区时候，试了一下国家电网的充电，和旁边特斯拉车主各种交流。最后让她扫了我的二维码，邀请成功。' +
        '回到住的地方又一次一键加电，2小时拿到车。现在开始满电跑杭州的9个景点活动！一键加电太爽了，我就担心我的能量无忧不够用啊！',
      ],
    },
    title: '看完一场电影  ES8 已经满电待命',
    description: `来看看创始版第509号上海车主@文海hai怎样在碎片时间里呼叫 一键加电，享受闲暇时光的同时完成补能。`,
  };
}
